<template lang="pug">
  .action-coins
    SectionHeader(:header="header")

    .action__body
      .action__profile(v-if="profile") 
        .action__profile-header
          img.action__profile-avatar(:src="profile.avatar")
          span.action__profile-name {{ profile.name }}
        .action__profile-bottom
          span.action__profile-label G-CASH Баланс игрока
          .profile__currency
            img.action__profile-currency-icon(:src="require('@/assets/img/icons/coins.svg')" alt="G-cash") 
            span.action__profile-currency-value {{ profile.g / 100 }}

      .action__section
        .action__grid
          .action__form-field(v-for="(item, i) of items" :key="i")
            InputSmart(:item="item")

      .action__bottom
        Button(is-primary @click="onCheckButtonClick") {{ buttonText }}

</template>

<script>
import { debounce } from '@/utils/utils.js'
import { mapActions } from 'vuex'
import InputSmart from '@/components/InputSmart/InputSmart'
import SectionHeader from '@/components/SectionHeader/SectionHeader'

export default {
  name: 'ActionMoney',

  components: {
    InputSmart,
    SectionHeader,
  },

  data: () => ({
    profile: undefined,
    money: null,

    items: {
      playerId: {
        title: 'ID игрока',
        value: null,
        type: 'number',
        placeholder: 'Введите ID',
      },

      isAdd: {
        title: 'Действие',
        value: true,
        type: 'select',
        options: [
          { title: 'Начислить', value: true },
          { title: 'Списать', value: false },
        ],
        withEmptyValue: false,
      },

      money: {
        title: 'Количество',
        value: null,
        type: 'number',
        placeholder: 'Сколько душа пожелает',
        error: '',
        min: 0,
      },

      reasonItem: {
        title: 'Причина',
        value: 'tournaments',
        type: 'select',
        options: [
          { title: 'Tournaments', value: 'tournaments' },
          { title: 'Offerwalls', value: 'offerwalls'  },
          { title: 'Marketing ', value: 'marketing'  },
          { title: 'Balance correction', value: 'balance_correction'  },
          { title: 'Test ', value: 'test'  },
          { title: 'Other', value: 'other'  },
        ],
        withEmptyValue: false,
      },

      commentItem: {
        title: 'Комментарий',
        value: null,
        type: 'text',
        placeholder: 'Не должно быть пустым',
        required: true,
      },
    },
  }),

  computed: {
    gameName() {
      return this.$route.params.section
    },

    header() {
      return {
        title: `${this.$gameNameText(this.gameName)} / Списание и начисление G-cash`,
        game: this.gameName,
      }
    },

    debitedMoney() {
      return Math.min((this.profile?.g / 100), this.items?.money.value)
    },

    buttonText() {
      if(this.profile !== undefined && this.items?.money.value) {
        if(!this.items.isAdd.value) {
          return `Списать ${this.debitedMoney}`
        } else {
          return `Начислить ${this.items?.money.value}`
        }
      } else {
        return 'Изменить'
      }
    }
  },

  created() {
    this.$forceUpdate()
  },

  watch: {
    'items.money.value': {
      handler(newValue) {
        this.checkSum(this.profile?.g / 100, newValue)
      }
    },

    'items.isAdd.value': {
      handler() {
        this.checkSum(this.profile?.g / 100, this.items.money.value)
      }
    },

    'profile.g': {
      handler(newValue) {
        this.checkSum(newValue, this.items.money.value)
      }
    },

    'items.playerId.value': debounce(function (value) {
      if(value) {
        this.getBalance();
      } else [
        this.profile = undefined
      ]
    }, 700)
  },

  methods: {
    ...mapActions('modal', ['showModal']),

    async onCheckButtonClick() {
      this.$loading.start()

      try {
        const playerId = this.items.playerId.value
        const isAdd = this.items.isAdd.value
        let reason = this.items.reasonItem.value
        let comment = this.items.commentItem.value

        this.money = +this.items.money.value

        if (!isAdd) {
          if(this.items.money.error) {
            this.money = -Math.abs(this.profile?.g)
          } else {
            this.money = -Math.abs(this.money)
          }
        }

        if (!this.money) {
            return this.$loading.finish()
        }


        if (!comment) {
          this.showModal({
            component: 'ModalMessage',
            data: {
              type: 'error',
              title: 'Error',
              text: 'Комментарий обязателен! Заполните поле',
            },
          })
          return this.$loading.finish()
        }
        const { data } = await this.$axios.post(`/admin/user/${playerId}/balance/g-cash`, {
          amount: this.money,
          comment: comment,
          reason: reason
        })

        if (data.data) {
          this.showModal({
            component: 'ModalMessage',
            data: {
              type: 'success',
              title: 'Успех',
              text: 'Баланс игрока изменён!',
            },
          })

          this.items.money.error = ''
          this.items.money.value = null

          this.getBalance()
        }
      } catch (e) {
        this.$error.handle(e)
      }

      this.$loading.finish()
    },

    async getBalance() {
      try {
        const { data } = await this.$axios.get(`/admin/user/${this.items.playerId.value}/balance`)
        const profile = data.data;

        const response = await this.$axios.get(`/user/${this.items.playerId.value}`)
        profile.name = response.data?.data?.full_name
        profile.avatar = response.data?.data?.avatar

        this.profile = profile

      } catch (e) {
        console.error('BS account error', e)
        this.items.playerId.value = null

        this.$error.handle(e)
      }
    },

    checkSum(profileValue, fieldValue) {
      this.items.money.error = undefined
      if(!this.items.isAdd.value) {
        if(fieldValue > profileValue) {
          const diff = fieldValue - profileValue
          this.items.money.error = `На счете игрока не хватает ${diff.toFixed(2)} g-cash`
        }
      }
    },

    debounceInput: debounce(function () {
      this.profile = this.getBalance;
    }, 500) 
  },
}
</script>

<style lang="scss" scoped>
.action {
  &__profile {
    background-color: $blue-grey60;
    border-radius: 8px;
    padding: 20px 16px;
    max-width: 380px;
    margin-bottom: 8px;

    &-header {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin-bottom: 21px;
    }

    &-avatar {
      width: 48px;
      height: 48px;
      object-fit: cover;
      margin-right: 8px;
      border-radius: 24px;
    }

    &-name {
      color: $white;
      font-weight: 500;
      font-size: 16px;
      line-height: 20px;
    }

    &-bottom {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    &-label {
      color: $blue-grey10;
      font-weight: normal;
      font-size: 11px;
      line-height: 14px;
      letter-spacing: 0.02em;
      text-transform: uppercase;
    }

    &-currency-value {
      font-weight: 500;
      font-size: 18px;
      line-height: 22px;
      color: $white;
    }
  }
}
</style>
